import { ILegUTA, IUtaPolicy, getIsSpecialUtaPolicyTypeBenefit, getSpecialAndOtherUtas } from 'obt-common';
import { CheckCircle } from '@spotnana/pixel-react/dist/Icons';
import spotnanaTheme from '@spotnana/pixel-react/dist/utils';
import { UtaPolicyInfoItem } from '../../../AmenitiesAndUTA';
import { fare_rule_uta_list } from './styles';

interface IFareRuleUtas {
  utas: ILegUTA[];
}

function FareRuleUtas({ utas }: IFareRuleUtas) {
  const { specialUtas, otherUtas } = getSpecialAndOtherUtas(utas);
  return (
    <div css={fare_rule_uta_list}>
      {otherUtas.length > 0 &&
        otherUtas.map((utaInfo) => {
          if (utaInfo.key === 'baggage' && typeof utaInfo.displayText !== 'string') {
            const { carryOn, checkedBaggage, additionalCheckedBaggage } = utaInfo.displayText;
            return (
              <>
                {carryOn && (
                  <UtaPolicyInfoItem
                    key={utaInfo.key}
                    utaKey="carryOn"
                    utaDisplayText={carryOn?.replace('free & personal item', 'free carry-on & personal item')}
                    utaPolicy={utaInfo.uta.baggage?.carryOn[0]?.policy}
                    dataTestId="flight-checkout-v2-uta-item"
                    variant="default"
                  />
                )}
                {checkedBaggage && (
                  <UtaPolicyInfoItem
                    key={utaInfo.key}
                    utaKey="checkedBag"
                    utaDisplayText={checkedBaggage}
                    utaPolicy={utaInfo.uta.baggage?.checkedBag?.[0]?.policy}
                    dataTestId="flight-checkout-v2-uta-item"
                    variant="default"
                  />
                )}
                {additionalCheckedBaggage && (
                  <UtaPolicyInfoItem
                    key={utaInfo.key}
                    utaKey="additionalCheckedBag"
                    utaDisplayText={additionalCheckedBaggage}
                    utaPolicy={utaInfo.uta.baggage?.checkedBag?.[1]?.policy}
                    dataTestId="flight-checkout-v2-uta-item"
                    variant="default"
                  />
                )}
              </>
            );
          }
          if (typeof utaInfo.displayText === 'string') {
            return (
              <UtaPolicyInfoItem
                key={utaInfo.key}
                utaKey={utaInfo.key}
                utaDisplayText={utaInfo.displayText}
                utaPolicy={utaInfo.uta.seatType}
                dataTestId="flight-checkout-v2-uta-item"
                variant="default"
              />
            );
          }
          return null;
        })}

      {specialUtas.length > 0 &&
        specialUtas.map((utaInfo) => {
          const isSpecialUtaPolicyTypeBenefit = getIsSpecialUtaPolicyTypeBenefit(
            utaInfo.uta[utaInfo.key] as IUtaPolicy,
          );
          const utaPolicyInfoItemAdditionalProps = {
            ...(isSpecialUtaPolicyTypeBenefit && {
              icon: CheckCircle,
              textColor: spotnanaTheme.colors.text.darkGreen,
            }),
          };
          return (
            <UtaPolicyInfoItem
              key={utaInfo.key}
              utaKey={utaInfo.key}
              utaDisplayText={utaInfo.displayText as string}
              utaPolicy={undefined}
              dataTestId="flight-checkout-v2-uta-item"
              variant="default"
              {...utaPolicyInfoItemAdditionalProps}
            />
          );
        })}
    </div>
  );
}

export default FareRuleUtas;
